import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { OAuthConsentView } from "../features/oauth-consent/index.ts";

export const OAuthConsent: FC = () => (
  <PageContainer>
    <OAuthConsentView />
  </PageContainer>
);
